// Copyright 2020 Prescryptive Health, Inc.

export class LoginCancelledError extends Error {
  constructor() {
    super();
    Object.setPrototypeOf(this, LoginCancelledError.prototype);
  }
}
